import React from 'react';

const ChatLayout = ({ children }) => {
  return (
    <div id="chat-area" className="flex flex-col md:flex-row min-h-screen h-screen bg-[#f7f7f9]">
      {children}
    </div>
  );
};

export default ChatLayout; 